import React, { Component, useState, useEffect } from 'react';
import './drop-down.css';

let selectedValue = '';

const ReminderDropDown = (props) => {
    const [showItems, setShowItems] = useState(false);
    const [selectedItem, setSelectedItem] = useState({})
    const [items, setItems] = useState(props.list)

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        let item = items.filter((obj) => {
            if(obj.fields.key.value === props.defaultSelectedValue)
            return obj;
        })
        setSelectedItem(item[0]);
        selectedValue = item[0].fields.key.value;
    }, [props.defaultSelectedValue])

    const handleClickOutside = (event) => {
        // console.log(event.target.className)
        if (event.target.className === 'select-box--selected-item' && document.getElementsByClassName('select-box--arrow-down').length === 0) {
            setShowItems(true)
        }
        else if (event.target.className === 'select-box--arrow-down') {
            setShowItems(false)
        }
        else if (event.target.className === 'select-box--arrow-up') {
            setShowItems(true)
        } else {
            setShowItems(false)
        }

    }

    const dropDown = () => {
        // console.log(showItems);
        showItems ? setShowItems(false) : setShowItems(true)
    }

    const closeDropDown = () => {
        setShowItems(false)
    }

    const selectItem = (item) => {
        // console.log(item)
        let valueChange = false;
        if (selectedValue !== item.fields.key.value) {
            selectedValue = item.fields.key.value;
            valueChange = true;
        }
        console.log(valueChange)
        setSelectedItem(item);
        setShowItems(false);
        props.onReminderTimeChange(item, valueChange)
    }

    return (
        <div className="custom-select-dropdown">
            <div className="select-box--box" onClick={dropDown} onBlur={closeDropDown}>
                <div className="select-box--container"  >
                    <div className="select-box--selected-item">
                        {selectedItem.fields && selectedItem.fields.name.value}
                        {/* {this.state.selectedItem && this.state.selectedItem.value} */}
                    </div>
                    <div className="select-box--arrow" name="select-box--name" onClick={dropDown}>
                        <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>

                        </span>

                    </div>
                    <div style={{ display: showItems ? 'block' : 'none' }}
                        className="select-box--items"
                    >
                        {
                            items.map((item,index) => {
                                // if(index !==0)
                                return (
                                    <div
                                        key={item.fields.key.value}
                                        onClick={() => selectItem(item)}
                                        className={selectedItem === item ? 'selected' : ''}
                                    ><strong>
                                            {
                                                item.fields.name.value
                                            }
                                        </strong>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReminderDropDown;